import debug from "debug";

export const saveInStorage = (key: string, value: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (e) {
    debug("saveInStorage")(String(e));
    return false;
  }
};

export const getFromStorage = (key: string) => {
  let item;
  try {
    item = localStorage.getItem(key);
  } catch (e) {
    debug("getFromStorage")(String(e));
    item = null;
  }
  try {
    // @ts-expect-error
    return JSON.parse(item);
  } catch (e) {
    debug("getFromStorage")(String(e));
    return item;
  }
};
